import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { GenericApiErrorComponent } from '@shared/components/error/generic-api-error/generic-api-error.component';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { diningAttributesLoaded, selectDiningAttributes } from '@shared/store/shared';
import { catchError, combineLatest, map, of, switchMap, take, tap } from 'rxjs';
import { DiningAttribute } from '../../../shared/models/dining-attribute';

export const diningAttributesGuard: CanActivateFn = () => {
  const store = inject(Store);
  const snackBar = inject(MatSnackBar);
  const siteSettingsService = inject(SiteSettingsService);
  const http: HttpClient = inject(HttpClient);

  return combineLatest([siteSettingsService.isNewDining(), store.select(selectDiningAttributes)]).pipe(
    take(1),
    switchMap(([isNewDining, storedAttributes]) => {
      if (isNewDining && !storedAttributes?.length) {
        return http.get<DiningAttribute[]>(ApiEndpoint.DINING_ATTRIBUTES).pipe(
          tap((attributes) => store.dispatch(diningAttributesLoaded({ attributes }))),
          map(() => true),
          catchError(() => {
            snackBar.openFromComponent(GenericApiErrorComponent, { duration: 5000 });
            return of(false);
          })
        );
      } else {
        return of(true);
      }
    })
  );
};
